import Icon from 'vue-awesome/components/Icon'

Icon.register({
  motorcycle: {
    paths: [
      {
        d: 'M17.5 10c-.03 0-.05.01-.08.01L13.41 6H9v2h3.59l2 2h-8.1C4.01 10 2 12.02 2 14.5a4.494 4.494 0 008.92.77L13.04 14c-.02.17-.04.33-.04.5 0 2.49 2.01 4.5 4.5 4.5s4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm-8.66 5.26A2.488 2.488 0 016.47 17a2.5 2.5 0 010-5c1.12 0 2.05.74 2.37 1.75H6v1.5l2.84.01zM17.47 17a2.5 2.5 0 010-5 2.5 2.5 0 010 5z'
      }
    ],
    width: '24',
    height: '24'
  }
})
